import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Regulatory Affairs Foundations & Global Compliance Ecosystem",
    description:
      "Introduction to Regulatory Affairs & why it is essential, Role of RA professionals in pharma biotech & medical devices, Global health authorities overview: FDA (USA) EMA (Europe) CDSCO (India) MHRA (UK) WHO, Understanding compliance quality & safety standards, End-to-end product regulatory lifecycle",
  },
  {
    title: "Drug Development Process & Regulatory Pathways",
    description:
      "Phases of drug development: Discovery → Preclinical → Clinical, IND (Investigational New Drug) & NDA (New Drug Application), ANDA for generic drug approvals, Biosimilars & regulatory considerations, Requirements for small molecules vs biologics",
  },
  {
    title: "Clinical Trials, Ethics & Good Clinical Practices (GCP)",
    description:
      "Phases I II III IV clinical studies explained, Roles of CROs & investigators, Informed consent ethics committees & patient safety, ICH-GCP guidelines overview, Clinical trial documentation & reporting",
  },
  {
    title: "Pharmaceutical Quality Systems & GMP Compliance",
    description:
      "Good Manufacturing Practices (GMP) essentials, Quality Assurance (QA) vs Quality Control (QC), SOPs batch records & deviation handling, Audits inspections & risk management, Ensuring product purity safety & consistency",
  },
  {
    title: "Medical Device Regulations & ISO Standards",
    description:
      "Device classifications: Class I II III, FDA 510(k) PMA processes, EU MDR (Medical Device Regulation) overview, Risk management under ISO 14971, Labeling packaging & UDI (Unique Device Identification)",
  },
  {
    title: "Regulatory Strategies, Change Management & Lifecycle MaintenanceB",
    description:
      "Planning regulatory pathways for global approvals, Product variations renewals & periodic reports, Handling post-approval changes & safety updates, Managing recalls & corrective actions, Strategy building for faster market entry",
  },
  {
    title: "Pharmacovigilance (PV) & Post-Market Surveillance",
    description:
      "Role of PV in drug safety monitoring, Adverse event reporting (AERs), Signal detection & risk–benefit evaluation, PMS (Post-Market Surveillance) for medical devices, Ensuring long-term product safety",
  },
  {
    title: " Regulatory Tools, Documentation Workflow & Industry Software",
    description:
      "Dossier management systems (Veeva Vault eCTD tools), Document control & version control, Writing regulatory responses & justifications, Regulatory intelligence & tracking global updates, Professional communication in RA",
  },
  {
    title: "Dossier Preparation: CTD, eCTD & Technical Documentation",
    description:
      "Error handling, logging, code refactoring, performance improvement.",
  },
  {
    title: "Capstone Regulatory Affairs Project & Career Launchpad",
    description:
      "Preparing a mock CTD/eCTD dossier, Designing a regulatory strategy for a new drug/device, Reviewing clinical trial data & writing summaries, Portfolio creation for RA roles, Interview prep for Regulatory Affairs Associate Drug Safety Officer QA/QC roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
